import { render, staticRenderFns } from "./historyCard.vue?vue&type=template&id=7e1b13f0&scoped=true&"
import script from "./historyCard.vue?vue&type=script&lang=js&"
export * from "./historyCard.vue?vue&type=script&lang=js&"
import style0 from "./historyCard.vue?vue&type=style&index=0&id=7e1b13f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1b13f0",
  null
  
)

export default component.exports